module.exports = __webpack_public_path__ + "img/226.fbd9af51.jpg";